"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const react_1 = __importDefault(require("react"));
const PLACEHOLDER_HINTS = {
    firstName: 'e.g. John',
    lastName: 'e.g. Smith',
    aadharNumber: 'e.g. 1234 5678 9012',
    referredBy: 'Name of the person who referred you',
    couponCode: 'Enter your coupon code',
};
const TextField = ({ field, value, onChange, error, disabled }) => (react_1.default.createElement("div", { className: "field-group" },
    react_1.default.createElement("label", { className: "field-label", htmlFor: field.key },
        field.label,
        field.required && react_1.default.createElement("span", { className: "required" }, "*")),
    react_1.default.createElement("input", { id: field.key, type: field.type === 'number' ? 'number' : 'text', className: `field-input${error ? ' error' : ''}`, name: field.key, value: value || '', onChange: (e) => onChange(field.key, e.target.value), placeholder: PLACEHOLDER_HINTS[field.key] || `Enter ${field.label.toLowerCase()}`, disabled: disabled }),
    field.tooltip && react_1.default.createElement("div", { className: "field-hint" }, field.tooltip),
    error && react_1.default.createElement("div", { className: "field-error" }, error)));
exports.TextField = TextField;
